const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/sro/eCheckin/sections/Arzt.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import textMap from '../translations';
import _ from 'lodash';
import CIS4mSingleCheckbox from '@cistec/common_web/modules/CIS4m/components/CIS4mSingleCheckbox';
import { valueToBoolean } from '@cistec/common_web/modules/CIS4m/utils/data';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { ArztBlock } from 'App/components/eCheckin/components/fields/ArztBlock';
import { createFieldPath } from 'App/components/eCheckin/utils';
import { AddressFieldsConfig } from 'App/components/eCheckin/components/fields/AddressBlock';
import { useText } from '@cistec/common_web/utils/intlUtils';

const addressFieldsConfig: AddressFieldsConfig = {
    additionalInfo: {
        included: false,
    },
    country: {
        included: false,
    },
};

const arztFieldsConfig = {
    firstName: {
        required: false,
    },
    tel: {
        included: false,
    },
};


export const Arzt = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_KEIN_HAUSARZT = createFieldPath(path, 'noFamilyDoctor');

    const formData = useCIS4mData();
    const keinHausarzt = _.get(formData, PATH_KEIN_HAUSARZT) === '1';

    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <CIS4mSingleCheckbox
                label={textMap.keinHausarzt}
                path={PATH_KEIN_HAUSARZT}
                parseValue={valueToBoolean}
            />
            <ArztBlock
                basePath={path}
                fieldsConfig={arztFieldsConfig}
                addressFieldsConfig={addressFieldsConfig}
                hidden={keinHausarzt}
                required={!keinHausarzt}
            />
        </ECheckinSection>
    );
});

Arzt.displayName = 'Arzt';

export default Arzt;
